import { Input, Button, Form, Select, Checkbox, Switch, Upload, message, DatePicker } from 'antd';
import React                                                                          from 'react';
import { axios }                                                                      from '../../axios';

const FormTable = ({
                     buttonLabel,
                     data,
                     customStyle,
                     heading,
                     mainWidth,
                     saveFunc,
                     showSaveBtn,
                     initialValues,
                     multipleFiles
                   }) => {
  const [form] = Form.useForm();
  const props = {
    name: "file",
    multiple: !!multipleFiles, // Set to true for multiple file uploads
    action: "", // If you're using custom handling, you don't need this
    beforeUpload: (file) => {
      const isValidType = file.type.startsWith("image/");
      if (!isValidType) {
        message.error(`${ file.name } is not a valid file type.`);
      }
      return isValidType || Upload.LIST_IGNORE; // Prevent unsupported files from being uploaded
    },
    customRequest: async ({ file, onSuccess, onError }) => {
      const formData = new FormData();
      formData.append("files", file);

      try {
        const response = await axios.post("/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        onSuccess(response.data); // You can pass any response from the server
        message.success(`${ file.name } uploaded successfully!`);
      }
      catch (error) {
        console.error(error);
        onError(error);
        message.error(`${ file.name } upload failed.`);
      }
    },
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        message.success(`${ info.file.name } file uploaded successfully.`);
      }
      else if (status === "error") {
        message.error(`${ info.file.name } file upload failed.`);
      }
    },
  };
  let initialValuesData = initialValues && initialValues.reduce((acc, field) => {
    acc[field.value] = field?.defaultValue;
    return acc;
  }, {});

  return <Form
    layout="vertical"
    form={ form }
    onFinish={ () => {
      let formValues = form.getFieldsValue()
      saveFunc(formValues)
    } }
    initialValues={ initialValuesData }
    style={ {
      width: !!mainWidth ? mainWidth : "80%",
      margin: "auto"
    } }>
    <h3>{ heading }</h3>
    <div style={ customStyle }>
      { data.length > 0 && data.map((item, index) => (
        <Form.Item
          rules={ [{ required: item?.required, message: item?.required ? "This field is required!" : '' }] }
          style={ {
            width: "100%",
            gridColumn: item?.style?.gridColumn
          } }
          key={ index }
          label={ item.type === "checkBox" || item.type === "switch" ? null : item.label }
          name={ item.value }
          {...(item.type === "checkBox" || item.type === "switch" ? { valuePropName: "checked" } : item.type === "upload" ? {
            valuePropName: "fileList",
            getValueFromEvent:(e) => (Array.isArray(e) ? e : e?.fileList)
          } : {})}
        >
          { (item.type === "inp") ? (
            <Input
              size="normal"
              placeholder="Enter here"
              style={ {
                width: "100%"
              } }
              disabled={item?.disabled}
            />
          ) : item.type === "select" ? (
            <Select
              size="normal"
              placeholder="Select"
              options={ item.options }
              style={ {
                width: "100%"
              } }
            />
          ) : item.type === "checkBox" ?
            <Checkbox>{ item.label }</Checkbox> :
            item.type === "textArea" ?
              <Input.TextArea
                placeholder="Enter here"
                autoSize={ {
                  minRows: 3,
                  maxRows: 8,
                } }
              /> : item.type === "switch" ? <Form.Item
                  name={ item.value }
                  valuePropName="checked"
                  style={ { marginBottom: 0 } }
                >
                  <div style={ { display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" } }>
                    <span>{ item.label }</span>
                    <Switch size="small" onChange={ (checked) => form.setFieldsValue({ [item.value]: checked }) }/>
                  </div>
                </Form.Item>
                : item.type === "upload" ? <Upload.Dragger multiple={item?.multiple} maxCount={item?.maxCount}
                                                            { ...props }>
                  <p className="ant-upload-text" style={ {
                    padding: 20,
                    fontSize: 14
                  } }>Upload File</p>
                </Upload.Dragger> : item.type === "date" ? <DatePicker style={ {
                  width: "100%"
                } }/> : null }
        </Form.Item>
      )) }
    </div>
    { showSaveBtn === false ? null : <Form.Item className={ "button" } style={ {
      display: "flex",
      justifyContent: "end"
    } }>
      <Button size="normal" type="primary" htmlType={ "submit" }>
        { buttonLabel }
      </Button>
    </Form.Item> }
  </Form>
}

export default FormTable